// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__1cjRw","label":"TextInput_label__2P9tE","input":"TextInput_input__1_24M"};